export default __webpack_public_path__ + "static/media/home-white.25c237cc.svg";